import '@fortawesome/fontawesome-svg-core/styles.css';
import '@monorepo/ui/styles/DOC/prism.css';

import { AlgoliaProvider } from '@monorepo/ui/algolia/provider';
import React from 'react';

export * as global from '@monorepo/ui/styles/global.scss';

const config = require('@fortawesome/fontawesome-svg-core');
const { version } = require('../../package.json');

config.autoAddCss = false;

export const wrapRootElement = ({ element }) => <AlgoliaProvider>{element}</AlgoliaProvider>;

export const onRouteUpdate = ({ location }) => {
  console.info(`[scpo-ecoweb] v${version} — ${location.pathname}`);
};

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  const currentPosition = getSavedScrollPosition(location);
  window.scrollTo(...(currentPosition || [0, 0]));
  return false;
};
